<template>
  <div :class="className" class="wrapper">
    <div class="what-is-inside">
      <BbIcon size="small" name="arcane" type="filled" />
      <TextBody :i18n-key="titleKey" color="#FFD853" tag="div" />
    </div>

    <slot />
  </div>
</template>

<script>
import TextBody from '~/components/common/TextBody.vue';

export default {
  components: { TextBody },
  props: {
    titleKey: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  background-color: $bb-neutral-1;
  display: flex;
  flex-direction: column;
  gap: $bb-spacing-3;

  .what-is-inside {
    display: flex;
    align-items: center;
    gap: $bb-spacing-3;

    i {
      color: #ffd853;
    }
  }
}
</style>
